// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar .navbar-nav .nav-item a.active{
  color: #77C3F6 !important;
  font-weight: bold !important;
}

.list-notification .MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation0.MuiAccordion-root.Mui-expanded.css-1fjvggn-MuiPaper-root-MuiAccordion-root{
    border: '0px' !important;
  }

.list-notification .MuiAccordionDetails-root.css-1uh3lx7-MuiAccordionDetails-root{
    padding: '0px' !important;
}

 .css-1betqn-MuiAccordionSummary-content{
  margin: 0 !important;
}

.navbar-toggler{
  background: 'white' !important;
}`, "",{"version":3,"sources":["webpack://./src/components/header/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;IACI,wBAAwB;EAC1B;;AAEF;IACI,yBAAyB;AAC7B;;CAEC;EACC,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".navbar .navbar-nav .nav-item a.active{\r\n  color: #77C3F6 !important;\r\n  font-weight: bold !important;\r\n}\r\n\r\n.list-notification .MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation0.MuiAccordion-root.Mui-expanded.css-1fjvggn-MuiPaper-root-MuiAccordion-root{\r\n    border: '0px' !important;\r\n  }\r\n\r\n.list-notification .MuiAccordionDetails-root.css-1uh3lx7-MuiAccordionDetails-root{\r\n    padding: '0px' !important;\r\n}\r\n\r\n .css-1betqn-MuiAccordionSummary-content{\r\n  margin: 0 !important;\r\n}\r\n\r\n.navbar-toggler{\r\n  background: 'white' !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
